import { useEffect, useState } from "react";
import { toast } from "sonner";
import { leadsScript, leadsSaveScript } from "../lib/api";

const errText = (e, d) => { const x = e?.response?.data?.detail; return typeof x === "string" ? x : d; };

// The company's call script, with the customer's name filled in. Admins can edit it.
export default function ScriptPanel({ who, company, rep }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  useEffect(() => { leadsScript().then(setData).catch(() => {}); }, []);
  if (!data) return null;
  const fill = (t) => t.replaceAll("{name}", who || "there").replaceAll("{company}", company || "your company").replaceAll("{rep}", rep || "me").replaceAll("{sender_company}", "our company");
  const save = async () => { try { setData(await leadsSaveScript(draft)); setEditing(false); toast.success("Script saved"); } catch (e) { toast.error(errText(e, "Only an admin can change the script")); } };
  return <div className="panel softphone-card script-panel" data-testid="call-script">
    <button className="script-head" onClick={() => setOpen(!open)}><b>Call script</b><small>{open ? "Hide" : "Show"}</small></button>
    {open && (editing
      ? <><textarea rows={14} value={draft} onChange={e => setDraft(e.target.value)} /><div className="softphone-actions"><button className="primary-button" onClick={save}>Save script</button><button className="outline-button" onClick={() => setEditing(false)}>Cancel</button></div>
        <small className="muted">Use {"{name}"}, {"{company}"}, {"{rep}"}, {"{sender_company}"}.</small></>
      : <><div className="script-body">{fill(data.script).split("\n").map((line, i) => /^[A-Z' ]{4,}$/.test(line.trim()) ? <h4 key={i}>{line}</h4> : <p key={i}>{line}</p>)}</div>
        <button className="link-button" onClick={() => { setDraft(data.script); setEditing(true); }}>Edit script</button></>)}
  </div>;
}
